module.exports = __webpack_public_path__ + "img/women_on_beach.c278dddc.jpg";